import React from "react";
import { Button, Modal } from "antd"

export const DeleteSellerDiscountModal = ({
   toggleDeleteDiscountModal,
   showDeleteSellerDiscountModal,
   handleDeleteSellerDiscount
}) => {
   return (
      <Modal
         visible={showDeleteSellerDiscountModal}
         closable={true}
         title={"Delete Discount"}
         onCancel={toggleDeleteDiscountModal}
         footer={[
            <Button
               className={'ml-2'}
               key="back"
               label={"Close"}
               onClick={toggleDeleteDiscountModal}
            >
               Close
            </Button>,
            <Button
               className={'ml-2'}
               key="submit"
               type="primary"
               // loading={isLoading}
               onClick={handleDeleteSellerDiscount}
            >
               Submit
            </Button>
         ]}
      >
         <div>
            <p>Are you sure you want to delete ?</p>
         </div>
      </Modal >
   )
}